import { RootState } from "./index";
import VuexPersistence from "vuex-persist";
import { config } from "@/shared/utils/config";

export const vuexLocal = new VuexPersistence<RootState>({
  storage: window.localStorage,
  key: `${config.siteSettings}-persist-store`,
  modules: ["userInfo", "topUpNavigation"],
});
